import { CircularProgress, Typography } from '@mui/material'

export function Loading() {
  return <div className={'singleMessagePanel'}>
    <CircularProgress/>
    <Typography textAlign="center">Loading...</Typography>
  </div>
}
